import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';
import dayjs from 'dayjs';

import getEnvConfig from 'utils/config/env';

import { IStatisticsMembers } from './members.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

export const analyticsMembersApi = createApi({
    reducerPath: 'analyticsMembers',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsMembers'],
    endpoints: builder => ({
        getMembers: builder.query<IStatisticsMembers, AnalyticsFiltersProps>({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    arrayFormat: 'bracket-separator',
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/statistic/members?${queryArgs}`,
                    method: 'GET',
                };
            },

            transformResponse: (response: {
                data: Omit<IStatisticsMembers, 'series'> & { series: any };
            }) => {
                const { series, members, ...rest } = response.data;
                return {
                    ...rest,
                    members: members.map(m => ({
                        ...m,
                        image: m.image
                            ? `${getEnvConfig().env.API_URL.replace(
                                  /api\/v3/,
                                  ''
                              )}${m.image}`
                            : null,
                    })),
                    series: series[0].map(s => ({
                        users: s.users,
                        timestamp: dayjs.unix(s.scale_unix).valueOf(),
                    })),
                };
            },
        }),
    }),
});

export const { useLazyGetMembersQuery } = analyticsMembersApi;
